import EarTraining808 from "./EarTraining808.vue";
export default {
  name: "EarTraining808Render",
  props: {
    review: {
      type: Object,
      default: () => {
        return null;
      }
    },
    reviewMode: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {
        return null;
      }
    }
  },
  watch: {
    data() {
      this.init();
    }
  },
  data() {
    return {
      answer: [],
      status: -1
    };
  },
  methods: {
    next() {
      this.$emit('next');
    },
    init() {
      this.answer = 'N';
    },
    onAnswer(answer) {
      console.log(answer, '-------');
      this.$emit('answer', answer);
    }
  },
  mounted() {
    this.init();
  }
};